import { useEffect } from 'react'
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch'
import { useMap } from 'react-leaflet'
import { cx } from '@epam/uui-core'

import 'leaflet-geosearch/assets/css/leaflet.css'
import css from './SearchField.module.scss'
import { useActions } from '../../hooks/redux/actions'
import L from 'leaflet'
import { useAppSelector } from '../../hooks/redux/redux'

export const SearchField = () => {
  const { setNewPointPosition, openNewPoint, closeNewPoint } = useActions()
  const { isNewPointFormOpened } = useAppSelector((state) => state.app)
  const map = useMap()

  useEffect(() => {
    const provider = new OpenStreetMapProvider()

    // @ts-ignore
    const searchControl = new GeoSearchControl({
      provider,
      position: 'bottomright',
      showMarker: false,
      classNames: {
        button: cx(css.button),
        form: cx(css.form),
      },
    })

    map.addControl(searchControl)

    map.on('geosearch/showlocation', function (result: any) {
      setNewPointPosition(new L.LatLng(result.location.y, result.location.x))
      if (!isNewPointFormOpened) {
        openNewPoint()
      }
    })

    const handleClick = () => {
      closeNewPoint()
      setNewPointPosition(null)
    }

    document
      ?.querySelector('.leaflet-control-geosearch .reset')
      ?.addEventListener('click', handleClick)

    return () => {
      map.removeControl(searchControl)
      document
        ?.querySelector('.leaflet-control-geosearch .reset')
        ?.removeEventListener('click', handleClick)
    }
  }, [map])

  return null
}
